import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollTaxDetailItem  {
    _originalTypeClassName = "zERP.BO.PayrollTaxDetailItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollTaxDetailItem.translate = translateService;
}
this.Id = null;
this.TaxPercentage = null;
this.Tax = null;
this.TaxableAmount = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TaxPercentage:any;
Tax:any;
TaxableAmount:any;
Salary:any;
static setSalary = ($this, value) => {
var oldValue = $this.Salary;
$this.Salary = value;
if (value != null) {
if (oldValue != null && oldValue.TaxDetail != null) { oldValue.TaxDetail = null; }
if ($this.Salary.TaxDetail !== $this) {
Domain.PayrollSalaryDetail.setTaxDetail(value, $this);
}
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}